/*正则验证相关

 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */
import {getResouce} from "@/common/js/common";

export default {
  validOrderNo(val){
    if(getResouce() === 'upcard'){
      return { valid: true, msg: "" };
    }
    if(getResouce() === 'o2o'){
      if(num.length === 17 || num.length === 15){
        return { valid: true, msg: "" };
      }else{
        return { valid: false, msg: this.$t("订单号有误，请检查是否输入正确！") };
      }
    }
    if (this.orderNo(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "订单号有误，请检查是否输入正确！" };
    }
  },
  validEmail(val) {
    if (this.email(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "Email有误，请检查是否输入正确！" };
    }
  },
  // 校验税号
  validTaxNumber(val) {
    if(val === null){
      return { valid: true, msg: "" };
    }
    if (this.taxNumber(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "税号有误" };
    }
  },
  validInvoiceTitle(val) {// 校验抬头
    if (this.invoiceTitle(val)) {
      return { valid: true, msg: "" };
    } else {
      return { valid: false, msg: "抬头长度小于100"};
    }
  },
  /*订单号*/
  orderNo(num) {
    if(num == null){
      return false;
    }
    if(num.length >= 16 && num.length <= 35){
      return true;
    }
    return false;
  },
  /*手机号*/
  mobile(num) {
    return /^1[34578][0-9]{9}$/.test(num)
  },
  /*座机号码*/
  phone(num) {
    return /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,8}$/.test(num)
  },
  /*邮箱*/
  email(str) {
    if(str == null){
      return false;
    }
    return /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(str)
  },
  /*身份证*/
  idCard(str) {
    return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(str)
  },
  /*整数*/
  intNum(num) {
    return /(^[0-9]*$)/.test(num)
  },
  /*整数或小数*/
  intOrFloatNum(str) {
    return /^[0-9]+(\.[0-9]+)?$/.test(str)
  },
  /*至少包含2种字符的6到16位密码*/
  password(str) {
    return /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,16}$/.test(str)
  },
  /*5位数字验证码*/
  code(num) {
    return /^\d{5}$/.test(num)
  },

  /*发票代码    10或12位数字或大写字母*/
  invoiceCode(num) {
    return /^[A-Z0-9]{10}$/.test(num) || /^[A-Z0-9]{12}$/.test(num)
  },

  /*发票号码  8位数字*/
  invoiceNo(num) {
    return /^\d{8}$/.test(num)
  },

  /*发票代码或号码    需求5482，【发票代码、发票号码】可能是【数字、大小写英文】，且最多是25位*/
  invoiceCodeNo(str) {
    var reg = /^[a-zA-Z0-9]+$/;
    if(str.length > 25 || !reg.test(str)){
      return false;
    }
    return true;
  },

  /*是否是税号
  15-20位   英文数字 大写字母IOVZ除外
  */
  taxNumber(str) {
    if(str == null){
      return false;
    }
    //15-20位    中英文
    var reg = /^[0123456789ABCDEFGHJKLMNPQRTUWXY]+$/;
    var reg1 = /^\d{6}$/;
    if (str.length > 21 || str.length < 15 || !reg.test(str)) {
      return false;
    }
    /*
    if (str.indexOf("0") == 0) {
      return false;
    }
    var addressCode = str.substring(0, 6);
    if (!reg1.test(addressCode)) {
      return false;
    }*/
    return true;
  },
  /**验真发票抬头
   * 长度<100
   */
  invoiceTitle(str) {
    return str != null && str.length < 100 && str.length > 0;
  },
  /*是否是GUID  格式如2064d355-c0b9-41d8-9ef7-9d8b26524751 */
  guid(str) {
    return /^[A-Z0-9]{8}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{12}$/.test(str)
  },
  /**是否是YYYYMMDD格式日期
   * 如果是则返回日期，如果不是返回空
   */
  toDateFromString(strDate) {
    if (strDate.length != 8) {
      return null;
    }
    var dtDate = null;
    var nYear = parseInt(strDate.substring(0, 4), 10);
    var nMonth = parseInt(strDate.substring(4, 6), 10);
    var nDay = parseInt(strDate.substring(6, 8), 10);
    if (isNaN(nYear) == true || isNaN(nMonth) == true || isNaN(nDay) == true) {
      return null;
    }
    dtDate = new Date(nYear, nMonth - 1, nDay);
    if (nYear != dtDate.getFullYear() || (nMonth - 1) != dtDate.getMonth() || nDay != dtDate.getDate()) {
      return null;
    }
    return dtDate;
  }
}



// WEBPACK FOOTER //
// ./src/common/js/regexp.js